import { useMutation } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import CNPlanApis from 'apis/CNPlanApis';
import { GET_TEAM_SALES } from 'apis/GraphQL/Queries/teamSaleQuery';
import { PlantApi } from 'apis/PlantApis';
import { Button, ButtonFilter } from 'components';
import ButtonExport from 'components/Button/ButtonExport';
import ButtonImport from 'components/Button/ButtonImport';
import {
  ILazySelectData,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { UploadModal } from 'components/UploadModal_V2';
import { useTitle } from 'contexts/TitleProvider';
import { useUser } from 'contexts/UserProvider';
import dayjs from 'dayjs';
import useQueryParam from 'hooks/useQueryPrams';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { exportExcel_v3 } from 'utils/constants/exportExcel';
import { toastError, toastSuccess } from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';
import { IMPORT_PLANNING_TEAM } from 'utils/constants/importId';
import FilterCNPlan from './FilterCNPlan';
import TableCNPlan from './TableCNPlan';

const { PlusOutlined } = icons;
const paramsGetTeams = {
  query: GET_TEAM_SALES,
};
const CNPlan = () => {
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { user } = useUser();
  const childRef = useRef<any>(null);
  const { setTitle, setBreadcrumb } = useTitle();
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [data, setData] = useState<any>([]);
  const [dataPlant, setDataPlant] = useState<any>([{}]);
  const [isOpenImportModal, setIsOpenImportModal] = useState(false),
    [pageInfo, setPageInfo] = useState<any>([]),
    [dataSearch, setDataSearch] = useState<any>({}),
    navigate = useNavigate();
  const defaultFilter = useMemo(() => {
    if (user?.isCN)
      return {
        plantId: (user as any)?.plantCode,
        // ! Filter by year default
        year: dayjs(new Date().getFullYear().toString(), 'YYYY'),
      };

    return {
      // ! Filter by year default
      year: dayjs(new Date().getFullYear().toString(), 'YYYY'),
    };
  }, [user]);
  const defaultInput = useMemo(() => {
    return {
      plantId: {
        equals: defaultFilter.plantId,
      },
    };
  }, [defaultFilter]);

  // lưu trữ trạng thái edit truyền vào table ( là index của dòng đang edit)
  // 0: tạo mới, -1: không có dòng nào đang edit đồng nghĩa với nút save or cancel
  // > 0: dòng đang edit( chính là index của dòng đó trong data)
  const [edit, setEdit] = useState(-1);
  const [dataTeamsale, setDataTeamsale] =
    useState<ILazySelectData>(initLazySelectData);
  const [typeRevenueOptions, setTypeRevenueOptions] = useState<any>([]);
  const {
    isPending: getTypeRevenueOptionsLoading,
    mutate: getTypeRevenueOptions,
  } = useMutation({
    mutationFn: (data: any) => CNPlanApis.GetTypeRevenueComBoBox(data),
    onSuccess: (res) => {
      setTypeRevenueOptions(res.data.getCode.items);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { isPending: getCNPlantLoading, mutate: getCNPlants } = useMutation({
      mutationFn: (params: {
        page?: number;
        page_size?: number;
        input?: any;
        type?: any;
      }) => CNPlanApis.getRevenuePlanTeamSale(params),
      onSuccess: (res, variables) => {
        if (variables?.type === 'export') {
          const { headerRow } = childRef.current.getData();
          const [, ...others] = headerRow;
          const a = others.map((item: any) => {
            const newItem = { ...item };
            Object.keys(newItem).forEach((key) => {
              if (Array.isArray(newItem[key]) && newItem[key].length > 0) {
                newItem[key] = newItem[key][0];
              }
            });
            return newItem;
          });
          const processedData = res.data.getRevenueTteamsales.items.map(
            (item: any) => {
              const newItem = {
                ...item,
                teamSalesId: item?.tteamSales?.subId,
                tteamSale: item?.tteamSales?.name,
                unitMoney: 'triệu VND',
              };
              // Duyệt qua tất cả các thuộc tính của item
              Object.keys(newItem).forEach((key) => {
                key === 'unitMoney' && (newItem[key] = 'triệu VND');
                console.log('name', newItem[key], 'key', key);
                if (
                  typeof newItem[key] === 'object' &&
                  newItem[key] !== null &&
                  Object.prototype.hasOwnProperty.call(newItem[key], 'subId')
                ) {
                  newItem[key] = newItem[key].subId;
                } else if (
                  typeof newItem[key] === 'object' &&
                  newItem[key] !== null &&
                  Object.prototype.hasOwnProperty.call(newItem[key], 'name')
                ) {
                  newItem[key] = newItem[key].name;
                } else if (
                  typeof newItem[key] === 'object' &&
                  newItem[key] !== null &&
                  Object.prototype.hasOwnProperty.call(newItem[key], 'fullName')
                ) {
                  newItem[key] = newItem[key].fullName;
                }
              });
              return newItem;
            },
          );
          exportExcel_v3(
            a,
            processedData,
            '[CN] Phân bổ kế hoạch theo đội bán hàng',
            true,
          );
          return;
        }
        const data: any[] = res.data.getRevenueTteamsales.items;
        setData(
          data.map((item) => {
            const newItem = {
              ...item,
              tteamSale: item?.tteamSales?.name,
              tcreateUser:
                item.tcreateUser !== null ? item.tcreateUser.fullName : '',
              tmodifyUser:
                item.tmodifyUser !== null ? item.tmodifyUser.fullName : '',
            };
            return newItem;
          }),
        );
        setPageInfo(res.data.getRevenueTteamsales.pageInfo);
      },
      onError: (error) => {
        console.log(error);
      },
    }),
    { isPending: createCNPlanLoading, mutate: createCNPlan } = useMutation({
      mutationFn: (data: any) => CNPlanApis.createCNPlan(data),
      onSuccess: () => {
        getCNPlants({
          page: page,
          page_size: page_size,
          input: {
            ...(dataSearch.year
              ? {
                  year: { equals: parseInt(dataSearch.year.year().toString()) },
                }
              : {
                  year: { equals: parseInt(dayjs().year().toString()) },
                }),
            plantId: { equals: defaultFilter?.plantId ?? dataSearch.chiNhanh },
            teamSalesId: { equals: dataSearch.doi },
            ...(dataSearch?.typeRevenue && {
              typeRevenue: { equals: dataSearch?.typeRevenue },
            }),
          },
        });
        toastSuccess('Tạo mới thành công');
      },
      onError: (error) => {
        toastError('Tạo mới thất bại');
        console.log(error);
      },
    }),
    // { isPending: getTeamSaleLoading, mutate: getTeamSales } = useMutation({
    //   mutationFn: (params: IFilterTeamSaleCb) =>
    //     SaleTeamApi.getAllTeamSaleCb(params),
    //   onSuccess: (res) => {
    //     if (res?.data?.getTeamSales) {
    //       if (user?.isAdmin) {
    //         setDataTeamsale({
    //           options: res?.data?.getTeamSales?.items ?? [],
    //           totalItems: res?.data?.getTeamSales?.pageInfo?.totalItems ?? 0,
    //         });
    //       } else {
    //         setDataTeamsale({
    //           options: filterTeamByPlantId(
    //             user?.plantCode,
    //             res.data.getTeamSales.items,
    //           ),
    //           totalItems: res?.data?.getTeamSales?.pageInfo?.totalItems ?? 0,
    //         });
    //       }
    //     }
    //   },
    //   onError: (error) => {
    //     console.log(error);
    //   },
    // }),
    // { isPending: getTeamSaleLoading, mutate: getTeamSales } = useMutation({
    //   mutationFn: () => axiosGraphQL.post('/graphql', paramsGetTeams),
    //   onSuccess: (res) => {
    //     if (user?.isAdmin) {
    //       setDataTeamsale(res.data.getTeamSales.items);
    //     } else {
    //       setDataTeamsale(
    //         filterTeamByPlantId(user?.plantCode, res.data.getTeamSales.items),
    //       );
    //     }
    //   },
    //   onError: (error) => {
    //     console.log(error);
    //   },
    // }),
    { isPending: updateTeamSaleLoading, mutate: updateTeamSales } = useMutation(
      {
        mutationFn: (data: any) => CNPlanApis.updateCNPlan(data),
        onSuccess: (res: any) => {
          console.log(res);

          if (res.errors?.length) {
            toastError('Cập nhật thất bại');
            return;
          }

          getCNPlants({
            page: page,
            page_size: page_size,
            input: {
              ...(dataSearch.year
                ? {
                    year: {
                      equals: parseInt(dataSearch.year.year().toString()),
                    },
                  }
                : {
                    year: { equals: parseInt(dayjs().year().toString()) },
                  }),
              plantId: {
                equals: defaultFilter?.plantId ?? dataSearch.chiNhanh,
              },
              teamSalesId: { equals: dataSearch.doi },
              ...(dataSearch?.typeRevenue && {
                typeRevenue: { equals: dataSearch?.typeRevenue },
              }),
            },
          });
          toastSuccess('Cập nhật thành công');
        },
        onError: (error) => {
          console.log(error);
          toastError('Cập nhật thất bại');
        },
      },
    ),
    { isPending: getPlantLoading, mutate: getPlant } = useMutation({
      mutationFn: () => PlantApi.getAllPlant(),
      onSuccess: (res) => {
        setDataPlant(res.data.getPlant.items);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  useEffect(() => {
    // getTeamSales({ pageSize: 10 });
    getPlant();
    getTypeRevenueOptions('DT');
  }, []);
  useEffect(() => {
    !edit && setIsOpenFilter(false);
  }, [edit]);

  useEffect(() => {
    setTitle('[CN] Phân bổ kế hoạch theo đội bán hàng');
    setBreadcrumb([{ title: 'Kế hoạch' }, { title: '[CN] Kế hoạch' }]);

    getCNPlants({
      page: page,
      page_size: page_size,
      input: {
        ...(dataSearch.year
          ? {
              year: { equals: parseInt(dataSearch.year.year().toString()) },
            }
          : {
              year: { equals: parseInt(dayjs().year().toString()) },
            }),
        plantId: { equals: defaultFilter?.plantId ?? dataSearch?.chiNhanh },
        teamSalesId: { equals: dataSearch?.doi },
        ...(dataSearch?.typeRevenue && {
          typeRevenue: { equals: dataSearch?.typeRevenue },
        }),
      },
    });
  }, [page, page_size, defaultFilter, dataSearch]);

  // useEffect(() => {

  // }, [dataSearch, defaultFilter]);

  // button tạo
  const handleAndRow = async () => {
    if (childRef && childRef.current) {
      childRef.current.handleeAddRow();
    }
  };

  const handleExportExcel = async () => {
    getCNPlants({
      type: 'export',
      input: {
        ...(dataSearch.year
          ? {
              year: { equals: parseInt(dataSearch.year.year().toString()) },
            }
          : {
              year: { equals: parseInt(dayjs().year().toString()) },
            }),
        plantId: { equals: defaultFilter?.plantId ?? dataSearch.chiNhanh },
        teamSalesId: { equals: dataSearch.doi },
        ...(dataSearch?.typeRevenue && {
          typeRevenue: { equals: dataSearch?.typeRevenue },
        }),
      },
    });
  };
  //button import
  const handleImport = async () => {
    setIsOpenImportModal(true);
  };

  // button lưu
  const handleRowChange = useCallback(
    (index: any, value: any, type: any) => {
      const {
        typeRevenueName,
        approval,
        tplant,
        tcreateUser,
        tteamSale,
        ...value2
      } = value;

      const value3 = { ...value2 };
      if (edit == 0 && !data[0]?.id) {
        if (type == 'update') {
          const { ttypeRevenue, tteamSales, createDate, ...value4 } = value3;
          updateTeamSales(value4);
          return;
        }

        createCNPlan(value3);
      } else {
        const { ttypeRevenue, tteamSales, createDate, ...value4 } = value3;
        updateTeamSales(value4);
      }
    },
    [data],
  );

  // button tìm kiếm
  const handleSearch = (values: any) => {
    navigate(`?page=1&page_size=${page_size}`);
    setDataSearch(values);
  };
  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter
            disabled={edit == -1 ? false : true}
            isOpen={isOpenFilter}
            setIsOpen={setIsOpenFilter}
          />
        </Col>
        <Col>
          <ButtonExport
            disabled={edit == -1 ? false : true}
            onClick={handleExportExcel}
          />
        </Col>
        <Col>
          <ButtonImport
            disabled={edit == -1 ? false : true}
            onClick={handleImport}
          />
        </Col>
        <Col>
          <Button
            fill
            title="Tạo"
            iconBefore={<PlusOutlined />}
            handleOnclick={handleAndRow}
            disabled={edit !== -1}
          />
        </Col>
      </Row>
      <UploadModal
        unitTable="Đơn vị: triệu VND"
        okTitle="Gửi đề xuất"
        importId={IMPORT_PLANNING_TEAM}
        open={isOpenImportModal}
        title={'Import'}
        setOpen={setIsOpenImportModal}
        templateFileName="Kế Hoạch - [CN] Phân bổ kế hoạch theo đội bán hàng"
        refetch={() => {
          getCNPlants({
            page: page,
            page_size: page_size,
            input: {
              ...(dataSearch.year
                ? {
                    year: {
                      equals: parseInt(dataSearch.year.year().toString()),
                    },
                  }
                : {
                    year: { equals: parseInt(dayjs().year().toString()) },
                  }),
              plantId: {
                equals: defaultFilter?.plantId ?? dataSearch.chiNhanh,
              },
              teamSalesId: { equals: dataSearch.doi },
              ...(dataSearch?.typeRevenue && {
                typeRevenue: { equals: dataSearch?.typeRevenue },
              }),
            },
          });
        }}
      />

      <FilterCNPlan
        typeRevenueOptions={typeRevenueOptions}
        dataSearch={dataSearch}
        setDataSearch={setDataSearch}
        dataPlant={dataPlant}
        onSearch={handleSearch}
        isOpen={isOpenFilter}
        defaultFilter={defaultFilter}
      />

      <TableCNPlan
        dataTypeRevenue={typeRevenueOptions}
        page={page}
        page_size={page_size}
        onRowChange={handleRowChange}
        data={data}
        pageInfo={pageInfo}
        setData={setData}
        edit={edit}
        setEdit={setEdit}
        ref={childRef}
        dataTeams={dataTeamsale}
        dataPlants={dataPlant}
        loading={
          getCNPlantLoading ||
          createCNPlanLoading ||
          // getTeamSaleLoading ||
          updateTeamSaleLoading ||
          getPlantLoading ||
          getTypeRevenueOptionsLoading
        }
      />
    </>
  );
};

export default CNPlan;
